<template>
  <b-container fluid class="landing">
    <b-row>
      <b-col class="col-10 mx-auto py-5 my-5">
        <h5 class="section-title mb-5">Políticas de Privacidad</h5>
        <div class="policy-document">
          <p class="update-date">
            <strong>Última actualización:</strong> Diciembre 2025
          </p>

          <section class="policy-section">
            <h3>1. INFORMACIÓN GENERAL</h3>
            <p>
              En GOX (Puntos GOX), nos comprometemos a proteger tu privacidad y
              la seguridad de tus datos personales. Esta Política de Privacidad
              describe cómo recopilamos, usamos, compartimos y protegemos tu
              información personal cuando utilizas nuestra aplicación móvil y
              servicios de programa de fidelización.
            </p>
            <p>
              GOX es un programa de fidelización que permite a los usuarios
              acumular puntos por sus compras en establecimientos afiliados para
              canjearlos por beneficios exclusivos.
            </p>
          </section>

          <section class="policy-section">
            <h3>2. DATOS QUE RECOPILAMOS</h3>
            <h4>2.1 Datos de Registro</h4>
            <ul>
              <li>Nombre completo</li>
              <li>Número de documento de identidad</li>
              <li>Correo electrónico</li>
              <li>Número de teléfono</li>
              <li>Fecha de nacimiento</li>
              <li>Género</li>
            </ul>

            <h4>2.2 Datos de Uso de la Aplicación</h4>
            <ul>
              <li>Historial de transacciones y compras</li>
              <li>Puntos acumulados y canjeados</li>
              <li>Establecimientos visitados</li>
              <li>Preferencias de productos y servicios</li>
              <li>Cupones activados y utilizados</li>
            </ul>

            <h4>2.3 Datos Técnicos</h4>
            <ul>
              <li>Tipo de dispositivo y sistema operativo</li>
              <li>Dirección IP</li>
              <li>Identificadores únicos del dispositivo</li>
              <li>Datos de geolocalización (con tu consentimiento)</li>
              <li>Cookies y tecnologías similares</li>
            </ul>
          </section>

          <section class="policy-section">
            <h3>3. CÓMO UTILIZAMOS TUS DATOS</h3>
            <ul>
              <li>Gestionar tu cuenta y programa de fidelización</li>
              <li>Procesar transacciones y acumulación de puntos</li>
              <li>Enviarte notificaciones sobre tu cuenta, puntos y ofertas</li>
              <li>
                Personalizar tu experiencia y ofrecerte promociones relevantes
              </li>
              <li>
                Mejorar nuestros servicios y desarrollar nuevas funcionalidades
              </li>
              <li>Prevenir fraudes y garantizar la seguridad</li>
              <li>Cumplir con obligaciones legales y regulatorias</li>
              <li>Realizar análisis estadísticos y de mercado</li>
            </ul>
          </section>

          <section class="policy-section">
            <h3>4. COMPARTIR INFORMACIÓN</h3>
            <p>Podemos compartir tu información con:</p>
            <ul>
              <li>
                <strong>Establecimientos afiliados:</strong> Para procesar tus
                puntos y transacciones
              </li>
              <li>
                <strong>Proveedores de servicios:</strong> Que nos ayudan a
                operar la plataforma (hosting, análisis, soporte)
              </li>
              <li>
                <strong>Autoridades:</strong> Cuando sea requerido por ley o
                para proteger nuestros derechos
              </li>
            </ul>
            <p>No vendemos ni alquilamos tus datos personales a terceros.</p>
          </section>

          <section class="policy-section">
            <h3>5. TUS DERECHOS</h3>
            <p>
              De acuerdo con la Ley de Protección de Datos Personales del Perú
              (Ley N° 29733), tienes derecho a:
            </p>
            <ul>
              <li>Acceder a tus datos personales</li>
              <li>Rectificar datos inexactos o incompletos</li>
              <li>
                Cancelar tus datos cuando consideres que no están siendo
                tratados conforme a la ley
              </li>
              <li>Oponerte al tratamiento de tus datos</li>
              <li>Solicitar la portabilidad de tus datos</li>
              <li>Revocar tu consentimiento en cualquier momento</li>
            </ul>
            <p>
              Para ejercer estos derechos, contáctanos en:
              <a href="mailto:atencionalcliente@puntosgox.com"
                >atencionalcliente@puntosgox.com</a
              >
            </p>
          </section>

          <section class="policy-section">
            <h3>6. SEGURIDAD DE TUS DATOS</h3>
            <p>
              Implementamos medidas técnicas y organizativas apropiadas para
              proteger tus datos personales contra acceso no autorizado,
              pérdida, destrucción o alteración. Esto incluye:
            </p>
            <ul>
              <li>Cifrado de datos sensibles</li>
              <li>Controles de acceso estrictos</li>
              <li>Auditorías de seguridad regulares</li>
              <li>Capacitación continua de nuestro personal</li>
            </ul>
          </section>

          <section class="policy-section">
            <h3>7. RETENCIÓN DE DATOS</h3>
            <p>
              Conservamos tus datos personales durante el tiempo necesario para
              cumplir con los fines para los que fueron recopilados, incluyendo
              requisitos legales, contables o de reporte. Los puntos GOX tienen
              una vigencia de 3 años desde su obtención.
            </p>
          </section>

          <section class="policy-section">
            <h3>8. MENORES DE EDAD</h3>
            <p>
              Nuestros servicios están dirigidos a personas mayores de 18 años.
              No recopilamos intencionalmente datos de menores sin el
              consentimiento de sus padres o tutores legales.
            </p>
          </section>

          <section class="policy-section">
            <h3>9. CAMBIOS A ESTA POLÍTICA</h3>
            <p>
              Podemos actualizar esta Política de Privacidad periódicamente. Te
              notificaremos sobre cambios significativos a través de la
              aplicación o por correo electrónico. Te recomendamos revisar esta
              política regularmente.
            </p>
          </section>

          <section class="policy-section">
            <h3>10. CONTACTO</h3>
            <p>
              Si tienes preguntas, comentarios o inquietudes sobre esta Política
              de Privacidad o el tratamiento de tus datos personales, puedes
              contactarnos:
            </p>
            <ul>
              <li>
                <strong>Correo electrónico:</strong>
                <a href="mailto:atencionalcliente@puntosgox.com"
                  >atencionalcliente@puntosgox.com</a
                >
              </li>
              <li>
                <strong>Sitio web:</strong>
                <a href="https://puntosgox.com" target="_blank"
                  >www.puntosgox.com</a
                >
              </li>
            </ul>
          </section>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import EventBus from "@/bus/index";

export default {
  name: "Privacy",
  components: {},
  data: () => ({
    show: true,
  }),
  created: function () {
    EventBus.$on("show-panel", (show) => {
      this.show = show;
    });
  },
  methods: {},
};
</script>
<style scoped>
.policy-document {
  font-family: "Raleway", sans-serif;
  line-height: 1.8;
  color: #333;
}

.update-date {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 2rem;
  font-style: italic;
}

.policy-section {
  margin-bottom: 2.5rem;
}

.policy-section h3 {
  color: #2c3e50;
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 1rem;
  border-bottom: 2px solid #e74c3c;
  padding-bottom: 0.5rem;
}

.policy-section h4 {
  color: #34495e;
  font-size: 1.1rem;
  font-weight: 600;
  margin-top: 1.5rem;
  margin-bottom: 0.8rem;
}

.policy-section p {
  margin-bottom: 1rem;
  text-align: justify;
}

.policy-section ul {
  margin-left: 1.5rem;
  margin-bottom: 1rem;
}

.policy-section ul li {
  margin-bottom: 0.5rem;
}

.policy-section a {
  color: #e74c3c;
  text-decoration: none;
  font-weight: 600;
}

.policy-section a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .policy-section h3 {
    font-size: 1.2rem;
  }

  .policy-section h4 {
    font-size: 1rem;
  }

  .policy-document {
    font-size: 0.95rem;
  }
}
</style>
